import useViewTransitionNavigate from "Hooks/useViewTransitionNavigate";
import { TfiAlignRight } from "react-icons/tfi";
import Account from "../Account/Account";
import "./Navbar.scss";

export default function Navbar({ isOpen, toggle }) {
  const navigate = useViewTransitionNavigate();

  return (
    <div className="sticky top-0 z-[10] font-[Tajawal]">
      {/* حاوية الناف بار مع تأثير الزجاج المعتمد */}
      <nav className="h-16 bg-gray-100 dark:bg-gray-950  border-b border-gray-200 dark:border-white/5 shadow-sm">
        <div className="max-w-6xl flex flex-row-reverse items-center justify-between h-full px-4 mx-auto">
          {/* قسم اللوجو */}
          <div
            onClick={() => navigate("/cp")}
            className="flex items-center space-x-3 rtl:space-x-reverse cursor-pointer group"
          >
            <div className="relative">
              <img
                className="w-12 md:w-14 drop-shadow-md group-hover:scale-105 transition-transform duration-300"
                src={"/assets/images/logo.png"}
                alt="العالمية للابتوب"
              />
              {/* وهج خفيف خلف اللوجو */}
              <div className="absolute inset-0 bg-mainLight/10 blur-xl rounded-full -z-10 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          </div>

          {/* قسم الأزرار والحساب */}
          <div className="flex gap-3 items-center">
            {/* زر القائمة الجانبية (Mobile Toggle) */}
            <button
              onClick={() => toggle((prev) => !prev)}
              type="button"
              className={`inline-flex lg:hidden items-center justify-center w-10 h-10 rounded-xl border-2 transition-all duration-300 
                ${
                  isOpen
                    ? "bg-mainLight border-mainLight text-white shadow-lg shadow-mainLight/20"
                    : "border-mainLight/30 text-mainLight hover:bg-mainLight/10"
                }`}
              aria-expanded={isOpen}
            >
              <TfiAlignRight
                className={`text-xl transition-transform duration-500 ${
                  isOpen ? "rotate-180 scale-x-100" : ""
                }`}
              />
            </button>

            {/* مكون الحساب الشخصي */}
            <Account />
          </div>
        </div>
      </nav>
    </div>
  );
}
